// extracted by mini-css-extract-plugin
export default {"container":"LeftSidebar_container__NONsZ","label":"LeftSidebar_label__mokPu"};